import * as React from 'react';
import * as $ from 'jquery';
import * as _ from 'underscore';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import { getDefaultRequireValueMessage, IBackendParameter } from './BackendMethodConfigurator';
import { IPopupOptions } from '../../../pdc-platform/src/ts/actions/DialogActions';
import * as Utilities from '../../../_common/platform/ts/Utilities';
import { ParameterField } from './ParameterField';
import BooleanField from '../../../_common/platform/tsx/BooleanField';
import StringField from '../../../_common/platform/tsx/StringField';

export interface IProperties {
    value: IBackendParameter;
    glob: IGlob;

    onChange(value: IBackendParameter): void;
}

export function ExchangeObjectNameParameterField(props: { value: string; onChange(value: string): void }) {
    return (
        <ParameterField title={'Exchange Object Name'} clearable={false}>
            <StringField
                value={props.value || ''}
                allowNull={false}
                placeholder={'Default'}
                onChange={props.onChange}
            />
        </ParameterField>
    );
}

interface IBackendMethodParameterPopupOptions extends IPopupOptions {
    value: IBackendParameter;

    onChange(value: IBackendParameter): void;
}

function OptionsSelectPopup(props: {
    zIndex: number;
    options: IBackendMethodParameterPopupOptions;
    glob: IGlob;

    close(): void;
}) {
    const [size, setSize] = React.useState({
        height: 480,
        width: 600
    });
    const popoverBody = React.useRef<HTMLDivElement>(null);
    const [requireValue, setRequireValue] = React.useState<boolean>(props.options.value.requireValue === true);
    const [requireValueMessage, setRequireValueMessage] = React.useState<string>(
        props.options.value.requireValueMessage || ''
    );
    const [exchangeObjectName, setExchangeObjectName] = React.useState<string>(
        props.options.value.exchangeObjectName || ''
    );

    React.useEffect(() => {
        const dialog = popoverBody.current;

        setSize({
            height: dialog.clientHeight,
            width: dialog.clientWidth
        });
    }, []);

    const handleOKButtonClick = () => {
        props.close();

        if (typeof props.options.onChange === 'function') {
            const valueCopy = { ...props.options.value };

            if (requireValue) {
                valueCopy.requireValue = true;

                if (requireValueMessage.length > 0) {
                    valueCopy.requireValueMessage = requireValueMessage;
                } else {
                    delete valueCopy.requireValueMessage;
                }
            } else {
                delete valueCopy.requireValue;
                delete valueCopy.requireValueMessage;
            }

            if (exchangeObjectName.length > 0) {
                valueCopy.exchangeObjectName = exchangeObjectName;
            } else {
                delete valueCopy.exchangeObjectName;
            }

            props.options.onChange(valueCopy);
        }
    };

    const options = props.options;
    const popoverStyle = Utilities.getPopoverStyle(options, size);
    const style: React.CSSProperties = {
        display: 'block',
        left: popoverStyle.left,
        top: popoverStyle.top,
        zIndex: props.zIndex
    };

    let requireValueMessageElement: React.JSX.Element;

    if (requireValue) {
        requireValueMessageElement = (
            <ParameterField title={'Message to show when requied value is not found'} clearable={false}>
                <StringField
                    value={requireValueMessage}
                    allowNull={false}
                    placeholder={getDefaultRequireValueMessage(
                        options.value?.valueSource ?? { attribute: 'Value Source' }
                    )}
                    onChange={(value: string) => {
                        setRequireValueMessage(value);
                    }}
                />
            </ParameterField>
        );
    }

    let exchangeObjectNameElement: React.JSX.Element;

    if (options.value.valueSourceType === 'exchange-object') {
        exchangeObjectNameElement = (
            <ExchangeObjectNameParameterField
                value={exchangeObjectName}
                onChange={(value: string) => {
                    setExchangeObjectName(value);
                }}
            />
        );
    }

    return (
        <div className="attribute-options-select-dialog">
            <div
                className={'popover attribute-options-select-popover-grid ' + popoverStyle.side}
                style={style}
                ref={popoverBody}
            >
                <div className="arrow" style={{ top: popoverStyle.arrowTop }}></div>
                <h3 className="popover-header">
                    {'More Options'}

                    <button type="button" className="close" onClick={props.close}>
                        ×
                    </button>
                </h3>
                <div>
                    <div className="popover-body">
                        <ParameterField noTitle={true} clearable={false}>
                            <BooleanField
                                title={'Require Value'}
                                value={requireValue}
                                allowNull={false}
                                onChange={(value: boolean) => {
                                    setRequireValue(value);
                                }}
                            />
                        </ParameterField>

                        {requireValueMessageElement}

                        {exchangeObjectNameElement}
                    </div>
                </div>
                <div className="modal-footer">
                    <div className="btn btn-success button-confirm" onClick={handleOKButtonClick}>
                        {'OK'}
                    </div>

                    <button className="btn btn-default" onClick={props.close}>
                        {'Cancel'}
                    </button>
                </div>
            </div>

            <div className="modal-backdrop fade show"></div>
        </div>
    );
}

export default function BackendMethodParameterOptionsSelect(props: IProperties) {
    const handleOnChange = (value: IBackendParameter) => {
        if (typeof props.onChange === 'function') {
            props.onChange(value);
        }
    };

    const handleOnSelectorShow = (e) => {
        const offset = $(e.target).offset();

        props.glob.DialogActions.createPopup<IBackendMethodParameterPopupOptions>('custom', {
            value: props.value,
            top: offset.top,
            left: offset.left,

            onChange: handleOnChange,

            component: OptionsSelectPopup
        });
    };

    return (
        <div className="attribute-options-select">
            <div className="content">
                <span className="glyphicon glyphicon-cog" onClick={handleOnSelectorShow}></span>
            </div>
        </div>
    );
}
